import React from "react";
import Section from "../../../styles/Section.js";
import { Highlight } from "../../../styles/Utilities.js";
import { H3 } from "../../../styles/Headings.js";
import { P2, P3 } from "../../../styles/Paragraphs.js";
import Button from "../../../styles/Button.js";
import Image from "../../../components/Image.js";
import {
   Projects,
   Project,
   ProjectBody,
   ProjectButton
} from "./TeamNexaveSectionStyles.js";
import InView from "react-intersection-observer";

const projectVariant = {
   hidden: {
      y: 50,
      opacity: 0,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.4
         },
         opacity: {
            duration: 0.4
         }
      }
   },
   visible: i => ({
      y: 0,
      opacity: 1,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.4,
            delay: i
         },
         opacity: {
            duration: 0.4,
            delay: i
         }
      }
   })
};

function TeamNexaveSectionContainer() {
   return (
      <Section>
         <H3 center>
            Member of <Highlight>Team Nexave</Highlight>
         </H3>
         <P2
            center
            style={{ width: "49rem", maxWidth: "100%", margin: "1.2rem auto" }}
         >
            Team Nexave is a group of developers which constitutes me and two of
            my friend. We work on freelance and personal projects together.
            Following are some of our freelance works.
         </P2>
         <InView threshold={0.25}>
            {({ ref, inView }) => (
               <Projects ref={ref}>
                  <Project
                     custom={0}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={projectVariant}
                  >
                     <Image
                        className="project-img"
                        src="adalgo-digital-preview.png"
                        alt="adalgo digital project preview"
                     />
                     <ProjectBody>
                        <P2 fontMain dark style={{ fontWeight: 500 }}>
                           Adalgo Digital
                        </P2>
                        <ProjectButton
                           as="a"
                           href="https://adalgodigital.com/"
                           target="_blank"
                           inverse
                        >
                           Visit
                        </ProjectButton>
                     </ProjectBody>
                  </Project>
                  <Project
                     custom={0.3}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={projectVariant}
                  >
                     <Image
                        className="project-img"
                        src="adsclues-preview.png"
                        alt="adsclues preview"
                     />
                     <ProjectBody>
                        <P2 fontMain dark style={{ fontWeight: 500 }}>
                           Adsclues
                        </P2>
                        <ProjectButton
                           as="a"
                           href="https://adsclues.in/"
                           target="_blank"
                           inverse
                        >
                           Visit
                        </ProjectButton>
                     </ProjectBody>
                  </Project>
                  <Project
                     custom={0.5}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={projectVariant}
                  >
                     <Image
                        className="project-img"
                        src="haridwartaxiservice-preview.png"
                        alt="haridwar taxi service preview"
                     />
                     <ProjectBody>
                        <P2 fontMain dark style={{ fontWeight: 500 }}>
                           Haridwar Taxi Service
                        </P2>
                        <ProjectButton
                           as="a"
                           href="https://haridwartaxiservice.netlify.app/"
                           target="_blank"
                           inverse
                        >
                           Visit
                        </ProjectButton>
                     </ProjectBody>
                  </Project>
               </Projects>
            )}
         </InView>
         <div style={{ textAlign: "center", marginTop: "1.4rem" }}>
            <Button
               as="a"
               href="https://nexavedevs.netlify.app/"
               target="_blank"
            >
               Visit Team Site
            </Button>
         </div>
      </Section>
   );
}

export default TeamNexaveSectionContainer;
